import styled, { css } from 'styled-components';

import TextNative from '../../../Text';

const baseStyles = () => css`
  position: relative;
  letter-spacing: 0.0333333333em;
  font-weight: 400;
  font-smoothing: antialiased;
  line-height: 24px;
  padding-left: 12px;
  box-sizing: border-box;
`;

const marginStyles = ({ isActived, danger }) => css`
  ${danger &&
  css`
    margin-top: 0px;
  `};
  ${isActived &&
  !danger &&
  css`
    margin-top: 2px;
  `};
`;

const colorStyles = ({ theme, isActived, danger, disabled }) => css`
  ${isActived &&
  css`
    color: ${theme.colors.pri500} !important;
  `};

  ${danger &&
  css`
    color: ${theme.colors.red500} !important;
  `}
  ${disabled &&
  css`
    color: ${theme.colors.gra700} !important;
  `};
`;

const HelperText = styled(TextNative)`
  ${baseStyles};
  ${colorStyles};
  ${marginStyles};
`;

HelperText.defaultProps = {
  'data-testid': 'helpertext'
};

HelperText.propTypes = {
  isActived: false,
  danger: false
};

export default HelperText;
